import TravellerLabel from '../TravellerLabel/TravellerLabel';

import ProgressiveOriginalImage from './ProgressiveOriginalImage';

import type { ImageGuestType } from '@shared/types/hotel-information';

import STYLES from './ImageItemNode.module.scss';

type Props = {
  src: string;
  guestType?: ImageGuestType;
  travelInfo?: string;
};

const ImageItemNode = ({ guestType, src, travelInfo }: Props) => (
  <div className={STYLES.ImageItemNode}>
    <ProgressiveOriginalImage src={src} />
    {guestType && travelInfo && (
      <TravellerLabel travelInfo={travelInfo} guestType={guestType} />
    )}
  </div>
);

export default ImageItemNode;
